import { VendorBuyingAgreementDetailAdmin } from '../../../components/Vendor';

export function VendorBuyingAgreement() {
  return <VendorBuyingAgreementDetailAdmin />;
}
